import "./icon-link.scss";

import { bemCN } from "../../config/bem-classname";

import { FC, ReactNode } from "react";
import { Link } from "react-router";

type IconLinkProps = {
  icon: ReactNode;
  text: string;
  link?: string;
  onClick?: () => void;
};
const iconLinkCN = bemCN("icon-link");

export const IconLink: FC<IconLinkProps> = ({ icon, text, link, onClick }) => {
  return link ? (
    <Link className={iconLinkCN()} to={link}>
      {icon}
      <p>{text}</p>
    </Link>
  ) : (
    <div
      onClick={() => {
        onClick && onClick();
      }}
      className={iconLinkCN()}
    >
      {icon}
      <p>{text}</p>
    </div>
  );
};
